import React, { useState } from 'react';
import axios from "axios";
import 'toastr/build/toastr.min.css';
import toastr from 'toastr';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_CONTACT_FORM_SUBMIT;

        try {
            const apiUrl = `${apiBaseUrl}${Url}`;
            const response = await axios.post(apiUrl, formData);
            console.log(response.data.message);
            const message = response.data.message;
            if (message) {
                toastr.success(message);
            } else {
                toastr.error('Error: No message found.');
            }
            setFormData({ name: '', email: '', subject: '', message: '' }); // clear form
        } catch (error) {
            console.error('Error sending message:', error);
            toastr.error('Failed to submit the form. Please try again later.');
        }
    };

    return (
        <>
            <form className="row contact_form"
                  onSubmit={handleSubmit}>
                <div className="col-md-6">
                    <div className="form-group">
                        <input required type="text" className="form-control" id="name" name="name"
                               placeholder="Enter your name" value={formData.name}
                               onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <input required type="email" className="form-control" id="email" name="email"
                               placeholder="Enter email address" value={formData.email}
                               onChange={handleChange} />
                    </div>
                    <div className="form-group">
                        <input required type="text" className="form-control" id="subject" name="subject"
                               placeholder="Enter Subject" value={formData.subject}
                               onChange={handleChange} />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
          <textarea className="form-control different-control" name="message" id="message"
                    rows="5" placeholder="Enter Message" value={formData.message}
                    onChange={handleChange}></textarea>
                    </div>
                </div>
                <div className="col-md-12 text-right">
                    <button type="submit" className="button-contact">
                        <span>Send Message</span>
                    </button>
                </div>
            </form>
        </>


    );
};

export default ContactForm;
